import React from 'react';
import styled from '../../styles/styled-components';

export type ProgressProps = {
  progress: number;
};

export const Progress: React.SFC<ProgressProps> = ({ progress, ...rest }) => (
  <Container {...rest}>
    <Bar style={{ width: `${progress}%` }} progress={progress} />
  </Container>
);

const Container = styled.div`
  width: 100%;
  height: 20px;
  background-color: ${p => p.theme.grayBackground};
  border-radius: 3px;
`;

type BarProps = { progress: number } & JSX.IntrinsicElements['div'];

const Bar = styled<BarProps>(({ progress, ...rest }) => <div {...rest} />)`
  background-color: ${p => p.theme.primaryColor};
  height: 20px;
  border-radius: 3px;
  transition: width 1s;
  will-change: width;
`;
